import { render } from "./WishListSvgButton.vue?vue&type=template&id=54423786&scoped=true&lang=html"
import script from "./WishListSvgButton.vue?vue&type=script&lang=js"
export * from "./WishListSvgButton.vue?vue&type=script&lang=js"

import "./WishListSvgButton.vue?vue&type=style&index=0&id=54423786&scoped=true&lang=scss"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54423786"]])

export default __exports__